import { createStore, createTypedHooks, persist } from 'easy-peasy'
import { appModel } from './state'

/**
 * App State Store
 */
const storeModel = {
    ...appModel,
  }
  
  /**
   * Export Typed Hooks
   *
   * Creating and exporting typed versions of the hooks means we don't need to
   * apply typing information against them when using them in our components.
   */
  export const { useStore, useStoreState, useStoreActions, useStoreDispatch } =
    createTypedHooks<typeof storeModel>()
  
  /**
   * Export Store
   *
   * We have two options to create and export the store.
   *
   * 1. A non-persistent store where the values reset to defaults if the page is
   * refreshed.
   *
   * 2. A persistent store where the values are retained in session storage until
   * the user closes the browser. If necessary the store can be persisted in
   * local storage so values are retained even after the browser closes.
   *
   * Only one method can be exported. Comment/uncomment as required.
   */
  
  // export default createStore(storeModel) // Non-persistent store
  export default createStore(
    persist(storeModel, {
      // Storage options (see https://easy-peasy.now.sh/docs/api/persist.html)
      storage: 'sessionStorage', // sessionStorage | localStorage
    }),
    {
      // Store Config (see https://easy-peasy.now.sh/docs/api/store-config.html)
      name: 'csm', // Name the store using our app name
    },
  ) // Persistent store
  